import { render, staticRenderFns } from "./FirstRoundEnd.vue?vue&type=template&id=bfa27cf8&scoped=true"
import script from "./FirstRoundEnd.vue?vue&type=script&lang=js"
export * from "./FirstRoundEnd.vue?vue&type=script&lang=js"
import style0 from "./FirstRoundEnd.vue?vue&type=style&index=0&id=bfa27cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa27cf8",
  null
  
)

export default component.exports